<template>
  <button :disabled="disabled || loader" :class="[computedClasses, selectedClass]" class="rounded h-[42px] select-none">
    <Flex center class="px-4">
      <slot>
        <IconSolid :icon="icon" :class="label ? 'mr-2' : ''" v-if="icon && !loader" />
        <IconSolid :icon="loaderIcon" v-if="loader" />
        {{ !loader ? label : '' }}
      </slot>
    </Flex>
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: String,
  color: String,
  icon: String,
  disabled: Boolean,
  loader: Boolean,
  block: Boolean,
  outlined: Boolean,
  primary: Boolean,
  success: Boolean,
  danger: Boolean,
  alert: Boolean,
  dark: Boolean,
  gray: Boolean,
  light: Boolean,
  selected: Boolean,
})

const loaderIcon = 'fa-solid fa-spinner fa-spin'

const computedClasses = computed(() => [
  { 'text-black': props.dark || props.gray },
  {
    'text-white': !props.dark && !props.outlined && !props.gray && !props.light,
  },
  { 'w-full': props.block },
  { 'inline-block': !props.block },
  { 'opacity-50 cursor-auto': props.disabled || props.loader },
  { 'bg-primary-600 hover:bg-primary-700': props.primary && !props.outlined },
  {
    'border border-primary-600 hover:border-primary-700 text-primary-600': props.primary && props.outlined,
  },
  { 'bg-success-500 hover:bg-success-600': props.success && !props.outlined },
  {
    'border border-success-500 hover:border-success-600 text-success-500': props.success && props.outlined,
  },
  { 'bg-red-500 hover:bg-red-600': props.danger && !props.outlined },
  {
    'border border-red-500 hover:border-red-600 text-red-500': props.danger && props.outlined,
  },
  { 'bg-alert-500 hover:bg-alert-600': props.alert && !props.outlined },
  {
    'border border-alert-500 hover:border-alert-600 text-alert-500': props.alert && props.outlined,
  },
  { 'bg-gray-200 hover:bg-gray-300 border border-slate-300': props.gray },
  { 'border border-slate-400 hover:bg-gray-50 text-[#575757]': props.light },
])

const selectedClass = computed(() => {
  if (!props.selected || props.outlined) {
    return
  }
  if (props.primary) {
    return 'bg-primary-800 hover:bg-primary-800'
  }
  if (props.danger) {
    return 'bg-red-800 hover:bg-red-800'
  }
  if (props.alert) {
    return 'bg-alert-800 hover:bg-alert-800'
  }
  if (props.success) {
    return 'bg-success-800 hover:bg-success-800'
  }

  return
})
</script>
